import React from 'react';

/**
 * Component to display a compact double "down arrow" svg icon
 * @param {*} props - Generic parameter to pass along any desired props to the component
 */

const SvgCompactDoubleArrowIcon = (props) => (
  <svg
    id="CompactDoubleArrowIcon"
    data-name="Layer 1"
    viewBox="0 0 15 15"
    width="1em"
    height="1em"
    {...props}>
    <defs>
      <style>
        {
          '.MenuArrowIcon_svg__cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px}'
        }
      </style>
    </defs>
    <path
      className="MenuArrowIcon_svg__cls-1"
      d="M13.43 7.11L7.5 13.04 1.57 7.11"
    />
    <path
      className="MenuArrowIcon_svg__cls-1"
      d="M13.43 1.96L7.5 7.89 1.57 1.96"
    />
  </svg>
);

export default SvgCompactDoubleArrowIcon;
